// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .easycommerce-search-container .easycommerce-search-input {
    border: 1px solid var(--color-ec-border) !important;
    padding-left: 40px !important;
} */
.easycommerce-search-container .easycommerce-content-input,
.easycommerce-order-container {
    border: 1px solid var(--color-ec-table-stock);
    transition: 0.4s all ease-in-out;
    border-radius: 8px;
}
.easycommerce-search-container .easycommerce-content-input:hover {
    border: 1px solid var(--color-ec-secondary);
}
.easycommerce-search-container .easycommerce-content-input:focus,
.easycommerce-search-container .easycommerce-content-input:focus-visible {
    box-shadow: none !important;
}
.easycommerce-search-container .easycommerce-search-input:hover {
    border: 1px solid var(--color-ec-secondary) !important;
}
.easycommerce-search-container .easycommerce-search-input:focus,
.easycommerce-order-container:focus {
    outline: none !important;
    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);
}
.easycommerce .react-datepicker-wrapper:focus {
    border: 1px solid var(--color-ec-primary) !important;
    box-shadow: none !important;
}

.easycommerce-select-cat-container .easycommerce-select-cat-input:focus,
.easycommerce-search-container .easycommerce-select-shortby-input:focus {
    box-shadow: 0 0 0 1px var(--color-ec-primary) !important;
    border: 1px solid var(--color-ec-primary) !important;
}
.easycommerce-select-shortby-input:hover,
.easycommerce-select-cat-input:hover {
    color: var(--color-ec-body) !important;
}
a.button-default:active,
a.button-default:hover,
a.button-default:focus {
    border: none !important;
}
.easycommerce-datepicker {
    box-shadow: none !important;
    border-radius: none !important;
    border: none !important;
    background-color: none !important;
    color: none !important;
}
.easycommerce-datepicker:focus {
    box-shadow: none !important;
}`, "",{"version":3,"sources":["webpack://./spa/admin/easycommerce/css/store-products.css"],"names":[],"mappings":"AAAA;;;GAGG;AACH;;IAEI,6CAA6C;IAC7C,gCAAgC;IAChC,kBAAkB;AACtB;AACA;IACI,2CAA2C;AAC/C;AACA;;IAEI,2BAA2B;AAC/B;AACA;IACI,sDAAsD;AAC1D;AACA;;IAEI,wBAAwB;IACxB,sDAAsD;AAC1D;AACA;IACI,oDAAoD;IACpD,2BAA2B;AAC/B;;AAEA;;IAEI,wDAAwD;IACxD,oDAAoD;AACxD;AACA;;IAEI,sCAAsC;AAC1C;AACA;;;IAGI,uBAAuB;AAC3B;AACA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,uBAAuB;IACvB,iCAAiC;IACjC,sBAAsB;AAC1B;AACA;IACI,2BAA2B;AAC/B","sourcesContent":["/* .easycommerce-search-container .easycommerce-search-input {\n    border: 1px solid var(--color-ec-border) !important;\n    padding-left: 40px !important;\n} */\n.easycommerce-search-container .easycommerce-content-input,\n.easycommerce-order-container {\n    border: 1px solid var(--color-ec-table-stock);\n    transition: 0.4s all ease-in-out;\n    border-radius: 8px;\n}\n.easycommerce-search-container .easycommerce-content-input:hover {\n    border: 1px solid var(--color-ec-secondary);\n}\n.easycommerce-search-container .easycommerce-content-input:focus,\n.easycommerce-search-container .easycommerce-content-input:focus-visible {\n    box-shadow: none !important;\n}\n.easycommerce-search-container .easycommerce-search-input:hover {\n    border: 1px solid var(--color-ec-secondary) !important;\n}\n.easycommerce-search-container .easycommerce-search-input:focus,\n.easycommerce-order-container:focus {\n    outline: none !important;\n    box-shadow: 0px 2px 4.5px 0px var(--color-ec-tertiary);\n}\n.easycommerce .react-datepicker-wrapper:focus {\n    border: 1px solid var(--color-ec-primary) !important;\n    box-shadow: none !important;\n}\n\n.easycommerce-select-cat-container .easycommerce-select-cat-input:focus,\n.easycommerce-search-container .easycommerce-select-shortby-input:focus {\n    box-shadow: 0 0 0 1px var(--color-ec-primary) !important;\n    border: 1px solid var(--color-ec-primary) !important;\n}\n.easycommerce-select-shortby-input:hover,\n.easycommerce-select-cat-input:hover {\n    color: var(--color-ec-body) !important;\n}\na.button-default:active,\na.button-default:hover,\na.button-default:focus {\n    border: none !important;\n}\n.easycommerce-datepicker {\n    box-shadow: none !important;\n    border-radius: none !important;\n    border: none !important;\n    background-color: none !important;\n    color: none !important;\n}\n.easycommerce-datepicker:focus {\n    box-shadow: none !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
